/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Unexpectederror1Inputs */

const en_errors_unexpectederror1 = /** @type {(inputs: Errors_Unexpectederror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We encountered an error, please try again later or contact us`)
};

/**
* | output |
* | --- |
* | "We encountered an error, please try again later or contact us" |
*
* @param {Errors_Unexpectederror1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_unexpectederror1 = /** @type {((inputs?: Errors_Unexpectederror1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Unexpectederror1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_unexpectederror1(inputs)
});
export { errors_unexpectederror1 as "errors_unexpectedError" }